module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Uploaded-file-fd60fd80833f1e0dea24239e50eaa94d.svg";